import { inject, Injectable, signal } from '@angular/core';

import { ScriptLoaderService } from '@app/services/script-loader.service';

@Injectable({
  providedIn: 'root',
})
export class OpenaiChatkitService {
  private readonly scriptLoaderService = inject(ScriptLoaderService);
  private readonly _isChatkitReady = signal(false);
  private readonly _lastThreadId = signal<string | null>(null);

  public readonly isChatkitReady = this._isChatkitReady.asReadonly();

  public initChatkit(): void {
    this.scriptLoaderService.load('https://cdn.platform.openai.com/deployments/chatkit/chatkit.js');
    customElements.whenDefined('openai-chatkit').then(() => {
      this._isChatkitReady.set(true);
    });
  }

  public setLastThreadId(threadId: string | null): void {
    this._lastThreadId.set(threadId);
  }

  public getLastThreadId(): string | null {
    return this._lastThreadId();
  }
}
